import IpubPagination from './src/main'

/* istanbul ignore next */
IpubPagination.install = function(Vue) {
  Vue.component(IpubPagination.name, IpubPagination)
}

export default IpubPagination
